<script setup>
import XMarkIcon from '@/assets/icons/outline/XMarkIcon.vue'
import ButtonComponent from './ButtonComponent.vue';

defineProps({
    label: {
        type: String,
        required: true
    },
    confirm: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close', 'confirm'])
</script>

<template>
    <div
        class="fixed inset-0 z-50 flex h-full w-full flex-col items-center justify-center gap-8 backdrop-blur-md px-16 py-12 lg:px-64 lg:py-32 pointer-events-auto"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="label"
        >
        <div
            class="flex flex-col w-[720px] aspect-video shadow-md items-center bg-surface-primary backdrop-blur-lg rounded-lg px-6 py-4 text-neutral">
            <div class="flex flex-row justify-between w-full">
                <div class="text-2xl font-bold text-neutral">{{ label }}</div>
                <button @click="emit('close')">
                    <XMarkIcon class="w-6 h-6 stroke-neutral" />
                </button>
            </div>
            <div class="flex-grow w-full mt-4">
                <slot></slot>
            </div>
            <div v-if="confirm" class="flex flex-row justify-end w-full">
                <ButtonComponent @click="emit('confirm')" primary>Save</ButtonComponent>
            </div>
        </div>
    </div>
</template>
